import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions';
import CustomPivotGrid from '../../../UI/CustomPivotGrid/CustomPivotGrid';
import { storageEmpresaId, storageMonedaSigno, storageUsuarioId } from '../../../../shared/sessionData';
import { Typography, Grid } from '@material-ui/core';
import { formatNumberWithoutDecimals } from '../../../../shared/formatNumber';
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source';
import { getFormat } from '../../../../shared/pivotGridDefaults/cuboVentasFormat';
import FiltroPivotGrid from '../../../UI/FiltroPivotGrid/FiltroPivotGrid';
import { getMonthName } from '../../../../shared/fechas';

const PivotGridCuboVentas = (props) => {
  const { loading, datos, config, onLoadData, filtros, onUpdateData, onUpdateConfigFields } = props;
  const [signoMoneda] = useState(storageMonedaSigno());
  const [storageKey] = useState("cubo-ventas-pivot-grid");
  const [budgetConfig] = useState(getFormat(storageMonedaSigno()));
  const [customLoading, setCustomLoading] = useState(false);
  const [nombreFormato, setNombreFormato] = useState("ÚLTIMO FORMATO UTILIZADO");
  const [configFields, setConfigFields] = useState();
  const [rowsColumnsFixed, setRowsColumnsFixed] = useState(true);
  const [gridContainerOverflowX, setGridContainerOverflowX] = useState("hidden");
  const [selectedTotalRows, setSelectedTotalRows] = useState([]);
  const rowFieldsFromDataSource = useRef();
  const [scrollingMode, setScrollingMode] = useState("virtual");

  useEffect(() => {
    if (!config && !loading) {
      let fields = budgetConfig;
      let dataStorage = localStorage.getItem(storageKey);

      if (dataStorage) {
        let configStorage = JSON.parse(dataStorage);

        if (configStorage && configStorage.fields && configStorage.fields.length > 0)
          fields = configStorage.fields;
      }

      onCargarFormato(fields, "ÚLTIMO FORMATO UTILIZADO");
    }
  }, [config, loading]);

  const title = () => {
    return (
      <Typography variant="h5">
        {`CUBO DE VENTAS: ${nombreFormato}`}
      </Typography>
    )
  }

  const subTitle = () => {
    return (
      <Grid item xs={12} container spacing={1} justifyContent="flex-start">
        <FiltroPivotGrid
          aplicarFiltros={onAplicarFiltroClick}
          filtros={filtros}
          onUpdateFiltros={props.onUpdateFiltros}
        />
      </Grid>
    )
  }

  const onCellClick = (e) => { }
  const rawData = useMemo(() => { return datos; }, [datos]);
  const data = useCallback(() => { return processData(rawData); }, [rawData]);

  const processData = (data) => {
    return data && data.map((dato) => {
      return {
        rubro: dato.rubro,
        articulo: `${dato.idArticulo && dato.idArticulo.trimEnd()} - ${dato.articulo && dato.articulo.trimEnd()}`,
        cliente: dato.idCliente && dato.idCliente.trimEnd() !== ''
          ? `${dato.idCliente.trimEnd()} - ${dato.cliente && dato.cliente.trimEnd()}`
          : `${dato.cliente && dato.cliente.trimEnd()}`,
        vendedor: dato.vendedor,
        marca: dato.marca,
        categoriaCliente: dato.categoriaCliente,
        subrubro: dato.subrubro,
        zona: dato.zona,
        provincia: dato.provincia,
        anio: dato.anio,
        mes: dato.mes ? `${dato.mes < 10 ? `0${dato.mes}` : `${dato.mes}`} - ${ getMonthName(dato.mes - 1)}` : '',

        unidadesFacturadas: dato.unidadesFacturadas,
        unidadesPendientes: dato.unidadesPendientes,
        unidadesTotales: dato.unidadesTotales,

        netoFacturado: dato.netoFacturado,
        netoPendiente: dato.netoPendiente,
        netoTotal: dato.netoTotal,

        brutoFacturado: dato.brutoFacturado,
        brutoPendiente: dato.brutoPendiente,
        brutoTotal: dato.brutoTotal,

        descuento: dato.descuento,

        unidadesTotalComparacion: dato.unidadesTotalComparacion,
        unidadesDiferenciaComparacion: dato.unidadesDiferenciaComparacion,
        netoTotalComparacion: dato.netoTotalComparacion,
        netoDiferenciaComparacion: dato.netoDiferenciaComparacion,
        brutoTotalComparacion: dato.brutoTotalComparacion,
        brutoDiferenciaComparacion: dato.brutoDiferenciaComparacion,
      };
    });
  }

  const rawFields = useMemo(() => {
    return config && config.map((field) => {
      let esDifComparacion = field.name && field.name.indexOf('DiferenciaComparacion') > -1;
      let item = { ...field };
      let fieldFormat = budgetConfig.find((format) => format.name === field.name
        || (format.dataField && format.dataField === field.dataField));

      if (fieldFormat) {
        if (fieldFormat.caption)
          item["caption"] = fieldFormat.caption;

        if (fieldFormat.isMeasure !== undefined)
          item["isMeasure"] = fieldFormat.isMeasure;

        if (fieldFormat.format !== undefined)
          item["format"] = fieldFormat.format;

        if (fieldFormat.allowFiltering !== undefined)
          item["allowFiltering"] = fieldFormat.allowFiltering;

        if (fieldFormat.allowSorting !== undefined)
          item["allowSorting"] = fieldFormat.allowSorting;

        if (fieldFormat.allowSortingBySummary !== undefined)
          item["allowSortingBySummary"] = fieldFormat.allowSortingBySummary;
        if (fieldFormat.customizeText !== undefined)
          item["customizeText"] = fieldFormat.customizeText;
      }

      item["hide"] = selectedTotalRows.find((row) => row.id === field.dataField) === undefined;

      if (esDifComparacion) {
        item["summaryType"] = 'custom';

        if (item["dataField"])
          delete item["dataField"];

        let esDifCompUnidades = field && field.name === 'unidadesDiferenciaComparacion';
        let esDifCompNeto = field && field.name === 'netoDiferenciaComparacion';
        let esDifCompBruto = field && field.name === 'brutoDiferenciaComparacion';

        if (esDifCompUnidades) {
          item["calculateCustomSummary"] = function (options) {
            switch (options.summaryProcess) {
              case "start":
                options.totalValue = { totalActual: 0, totalComparacion: 0, count: 0 };
                break;
              case "calculate":
                options.totalValue.count += 1;
                options.totalValue.totalActual += options.value.unidadesTotales;
                options.totalValue.totalComparacion += options.value.unidadesTotalComparacion;
                break;
              case "finalize":
                options.totalValue = (options.totalValue.totalActual - options.totalValue.totalComparacion);
            }
          }
        } else if (esDifCompNeto) {
          item["calculateCustomSummary"] = function (options) {
            switch (options.summaryProcess) {
              case "start":
                options.totalValue = { totalActual: 0, totalComparacion: 0, count: 0 };
                break;
              case "calculate":
                options.totalValue.count += 1;
                options.totalValue.totalActual += options.value.netoTotal;
                options.totalValue.totalComparacion += options.value.netoTotalComparacion;
                break;
              case "finalize":
                options.totalValue = (options.totalValue.totalActual - options.totalValue.totalComparacion);
            }
          }
        } else if (esDifCompBruto) {
          item["calculateCustomSummary"] = function (options) {
            switch (options.summaryProcess) {
              case "start":
                options.totalValue = { totalActual: 0, totalComparacion: 0, count: 0 };
                break;
              case "calculate":
                options.totalValue.count += 1;
                options.totalValue.totalActual += options.value.brutoTotal;
                options.totalValue.totalComparacion += options.value.brutoTotalComparacion;
                break;
              case "finalize":
                options.totalValue = (options.totalValue.totalActual - options.totalValue.totalComparacion);
            }
          }
        }
      }

      return item;
    });
  }, [config, selectedTotalRows]);

  const fields = useCallback(() => { return rawFields; }, [rawFields]);

  const onAplicarFiltroClick = (desde, hasta, anioComparacion) => {
    let localConfig = [];
    if (dataSource) {
      localConfig = dataSource.fields();
    } else {
      let item = localStorage.getItem(storageKey);
      localConfig = item ? JSON.parse(item).fields : config;
    }

    localStorage.removeItem(storageKey);

    let formato = processFormato(localConfig);

    const request = {
      anioFiscal: undefined,
      idArchivo: undefined,
      mesFiscal: undefined,
      acumulado: false,
      anioComparacion,
      desde,
      hasta,
      idEmpresa: storageEmpresaId(),
      idUsuario: storageUsuarioId(),
      importacion: false,
    };

    onLoadData(request, formato);
  }

  const customizeTooltip = (args) => {
    const valueText = args.seriesName.indexOf('%') !== -1
      ? `${formatNumberWithoutDecimals(args.originalValue)}%`
      : args.seriesName.indexOf('unidades') !== -1
        ? args.originalValue
        : `${signoMoneda} ${formatNumberWithoutDecimals(args.originalValue)}`;

    return {
      html: `${args.seriesName}<div style='text-align: center;'>${valueText}</div>`,
    };
  }

  const [isLoadingDataSource] = useState([false]);
  const dataSource = new PivotGridDataSource({
    fields: fields(),
    store: {
      type: "array",
      data: data()
    },
    onLoadingChanged: (isLoading) => {
      if (!isLoading) {
        const fields = dataSource && dataSource.fields() && dataSource.fields().filter((field) => field.area === 'row');
        rowFieldsFromDataSource.current = fields;
      }
    },
    retrieveFields: false,
  });

  const onUpdateDataSource = () => {
  }

  const processFormato = (formato) => {
    formato && formato.forEach((field) => {
      let item = budgetConfig.find((format) => format.name === field.name
        || (format.dataField && format.dataField === field.dataField));

      if (item) {
        field["caption"] = item.caption;
        field["dataType"] = item.dataType;
        field["name"] = item.name;

        if (item.summaryType)
          field["summaryType"] = item.summaryType;

        if (!field.area)
          field["area"] = "filter";
      }
    });

    budgetConfig.forEach((field) => {
      let item = formato && formato.find((format) => format.name === field.name
        || (format.dataField && format.dataField === field.dataField));

      if (!item) {
        field.area = "filter";
        formato.push(field);
      }
    })

    return formato;
  }

  const onCargarFormato = useCallback((formato, nombreFormato, items = undefined) => {
    setNombreFormato(nombreFormato);
    formato = processFormato(formato);
    setEstaCargado(false);
    const datosCubo = items !== undefined ? items : datos;
    onUpdateData(datosCubo, formato, filtros);
  }, [datos, filtros]);

  //#region Overflow X

  const setOverflowX = (modoConfiguracion, fijarFilasColumnas) => {
    const overflowX = modoConfiguracion ? "auto" : fijarFilasColumnas ? "hidden" : "auto";
    setGridContainerOverflowX(overflowX);
  }

  //#endregion

  //#region Cambio Vista
  useEffect(() => {
    if (!configFields) {
      const item = props.configFields.find((c) => c.key === storageKey);
      const cf = item ? item.config : {};
      setConfigFields(cf);
    }
  }, [configFields, props.configFields, storageKey]);

  const orderedFields = useMemo(() => {
    return dataSource && dataSource.fields() && dataSource.fields().filter((field) => field.area === 'filter')
      .map((field) => {
        return {
          caption: field.caption && field.caption.replace('|', '') && field.caption.replace('-', ''),
          name: field.name,
        }
      })
      .sort((a, b) => { return a.caption < b.caption ? -1 : 1; });
  }, [dataSource]);

  useEffect(() => {
    if (configFields && configFields.showFields && orderedFields && orderedFields.length > 0) {
      orderedFields.forEach((field, index) => { dataSource.field(field.name, { areaIndex: index }); });
      dataSource.load();
    }
  }, [configFields, orderedFields, dataSource]);

  const onViewChange = useCallback((config) => {
    setCustomLoading(true);
    setConfigFields(config);
    onUpdateConfigFields(storageKey, config);
    setOverflowX(config.visible, rowsColumnsFixed);
    setTimeout(() => setCustomLoading(false), 500);
  }, [storageKey, dataSource, rowsColumnsFixed]);
  //#endregion

  //#region Fijar Filas y Columnas
  const onFixRowsColumns = useCallback(() => {
    let value = !rowsColumnsFixed;

    if (value && configFields && configFields.visible) {
      setConfigFields({
        showFields: false,
        showColums: false,
        showData: false,
        showFilter: false,
        showRows: false,
        visible: false,
      });
    }

    setCustomLoading(true);
    setRowsColumnsFixed(value);
    setOverflowX(configFields.visible, value);
    let scroll = value ? "virtual" : "standard";
    setScrollingMode(scroll);
    setTimeout(() => setCustomLoading(false), 500);
  }, [rowsColumnsFixed, configFields]);
  //#endregion

  //#region Customization

  //#region On Cell Prepared
  const isTotalDataRow = (cell) => (cell.area === 'data' && cell.rowType === 'T'
    && (cell.columnType === 'T' || cell.columnType === 'GT'));
  const lessThanCeroCell = (cell) => cell.area === 'data' && cell.rowType === 'D'
    && cell.columnType === 'GT' && cell.dataType === 'number' && cell.value && cell.value < 0;
  const isHeader = (cell) => cell.area === 'column' && cell.type === 'GT';
  const isTotalRow = (cell) => cell.area === 'row' && (cell.type === 'T' || cell.type === 'GT');
  const isGranTotal = (cell) => (cell.area === 'data' && cell.rowType === 'GT' && cell.columnType === 'GT')
    || (cell.area === 'column' && cell.type === 'GT' && cell.text === 'Gran Total');
  
  const hideStyle = useMemo(() => { return { fill: 'FFF', font: 'FFF', bold: true, border: null, display: 'none' } }, []);
  const style = useMemo(() => { return { 'font-size': 'small', 'text-transform': 'uppercase' } }, []);
  
  const onCellPrepared = React.useCallback((e) => {
    const { area, cellElement, cell, columnIndex } = e;

    cell.area = area;

    if (cell.area === 'column' && cell.type === 'GT' && containsSpecialChars(cell.text)) {
      cell.text = removeSpecialChars(cell.text);
      cellElement.innerHTML = removeSpecialChars(cellElement.innerHTML);
      cellElement.innerText = removeSpecialChars(cellElement.innerText);
    }

    let defaultStyle = style;
    const appearance = getConditionalAppearance(cell, columnIndex, selectedTotalRows);

    if (appearance)
      defaultStyle = getCssStyles(appearance);

    if ((cell.path && isTotalRow(cell)) || (cell.rowPath && isTotalDataRow(cell))) {
      let rowFields = rowFieldsFromDataSource.current;
      let pathIndex = cell.path ? cell.path.length - 1 : cell.rowPath.length - 1;
      let rowField = rowFields.find((row) => row.areaIndex === pathIndex);

      if (rowField && rowField.hide)
        defaultStyle = hideStyle;
    }

    Object.assign(cellElement.style, defaultStyle);
  });

  const specialChars = ['| ', '- '];

  const containsSpecialChars = (cellText) => {
    let contains = false;

    if (cellText) {
      specialChars.forEach((item) => {
        if (cellText.includes(item))
          contains = true;
      })
    }
    return contains;
  }

  const removeSpecialChars = (cellText) => {
    if (cellText) {
      cellText = cellText.replace('| ', '');
      cellText = cellText.replace('- ', '');
    }

    return cellText;
  }

  function getCssStyles({ fill, font, bold, border }) {
    let style = {
      'background-color': `#${fill}`,
      color: `#${font}`,
      'font-weight': bold ? 'bold' : undefined,
      'font-size': 'smaller',
      'text-transform': 'uppercase'
    };

    if (border)
      style['border-color'] = `#${border}`;

    return style;
  }

  function getConditionalAppearance(cell) {
    if (isTotalRow(cell) || isGranTotal(cell) || isTotalDataRow(cell))
      return { fill: 'ffbf66', font: '3F3F3F', bold: true, border: null };

    if (isHeader(cell))
      return { fill: 'dbf9ff', font: '3F3F3F', bold: true, border: null };

    if (lessThanCeroCell(cell))
      return { fill: 'ffafaf', font: '3F3F3F', bold: true, border: null };

    return { fill: 'FFFFFF', font: '3F3F3F', bold: false, border: null };
  }
  //#endregion

  //#region On Content Ready 
  const dataConfigFields = useMemo(() => { return budgetConfig.filter((item) => item.area === "data"); }, [budgetConfig]);

  const onContentReady = useCallback((e) => {
    let ds = e.component.getDataSource();
    let rowFields = ds.fields() && ds.fields().filter((item) => item.area === "row");
    rowFieldsFromDataSource.current = rowFields;

    if (rowFields && rowFields.length > 0 && dataConfigFields && dataConfigFields.length > 0) {
      let reload = false;

      rowFields.forEach((field) => {
        const dataField = dataConfigFields.find((item) => item.name === field.name);

        if (dataField) {
          ds.field(field.name, { area: "filter" });

          if (!reload)
            reload = true;
        }
      });

      if (reload)
        ds.load();
    }

    isLoadingDataSource[0] = false;
  }, [dataConfigFields]);

  //#endregion

  //#region Mostrart Total por row
  const [estaCargado, setEstaCargado] = useState(false);

  const onSelectedTotalRowsChange = useCallback((items) => {
    setCustomLoading(true);
    setSelectedTotalRows(items);
    props.onUpdateSelectedTotalRows(storageKey, items);
    setTimeout(() => setCustomLoading(false), 500);
  }, [storageKey]);

  useEffect(() => {
    if (props.selectedTotalRowsItems && props.selectedTotalRowsItems.length > 0 && !estaCargado) {
      const item = props.selectedTotalRowsItems.find((i) => i.key === storageKey);

      if (item) {
        onSelectedTotalRowsChange(item.rows);
        setEstaCargado(true);
      }
    }
  }, [props.selectedTotalRowsItems, estaCargado]);

  //#endregion

  //#endregion

  //#region Data Chart 
  const chartFields = budgetConfig
    .filter((f) => f.caption !== null && f.caption !== undefined)
    .sort((a, b) => a.caption.localeCompare(b.caption));
  const chartOptions = chartFields && chartFields.filter((f) => f.area === "row");
  const chartSeries = chartFields && chartFields.filter((f) => f.area === "data");
  const unidadesItems = []
    .concat(chartSeries && chartSeries.filter((f) => f.name && f.name.indexOf('unidades') > -1 && f.name.indexOf('Total') > -1))
    .concat(chartSeries && chartSeries.filter((f) => f.name && f.name.indexOf('unidades') > -1 && f.name.indexOf('DiferenciaComparacion') > -1));
  const brutosItems = []
    .concat(chartSeries && chartSeries.filter((f) => f.name && f.name.indexOf('bruto') > -1 && f.name.indexOf('Total') > -1))
    .concat(chartSeries && chartSeries.filter((f) => f.name && f.name.indexOf('bruto') > -1 && f.name.indexOf('DiferenciaComparacion') > -1));
  const netosItems = []
    .concat(chartSeries && chartSeries.filter((f) => f.name && f.name.indexOf('bruto') > -1 && f.name.indexOf('Total') > -1))
    .concat(chartSeries && chartSeries.filter((f) => f.name && f.name.indexOf('bruto') > -1 && f.name.indexOf('DiferenciaComparacion') > -1));
  const chartFilters = [
    {
      id: 'unidades',
      showMonto: false,
      nombre: 'Unidades',
      seriesItems: unidadesItems,
      chartItems: unidadesItems,
      orderItems: chartSeries && chartSeries.filter((f) => f.name && f.name.indexOf('unidades') > -1)
    },
    {
      id: 'bruto',
      showMonto: true,
      nombre: 'Importes Brutos',
      seriesItems: brutosItems,
      chartItems: brutosItems,
      orderItems: chartSeries && chartSeries.filter((f) => f.name && f.name.indexOf('bruto') > -1)
    },
    {
      id: 'neto',
      showMonto: true,
      nombre: 'Importes Netos',
      seriesItems: netosItems,
      chartItems: netosItems,
      orderItems: chartSeries && chartSeries.filter((f) => f.name && f.name.indexOf('neto') > -1)
    },
  ];

  const chartConfig = {
    fields: chartFields,
    options: chartOptions,
    series: chartSeries,
    filters: chartFilters,
    data: datos,
    extraFilters: ['marca', 'rubro', 'subrubro'],
    relatedFilter: true,
  };

  //#endregion

  return (
    <CustomPivotGrid
      title={() => title()}
      subTitle={() => subTitle()}
      dataSource={dataSource}
      loading={loading || customLoading}
      rawDatos={datos}
      rawFiltros={filtros}
      resetButton={false}
      exportToExcel={true}
      exportToPdf={true}
      fileName={'Cubo Ventas'}
      sheetName={"Cubo Ventas"}
      storageKey={storageKey}
      onCellClick={onCellClick}
      onCellPrepared={onCellPrepared}
      showConfig={true}
      customizeTooltip={customizeTooltip}
      onUpdateDataSource={onUpdateDataSource}
      onCargarFormato={onCargarFormato}
      configFields={configFields}
      onContentReady={onContentReady}
      chartConfig={chartConfig}
      onViewChange={onViewChange}
      showChart={true}
      showChartIcon={false}
      rowsColumnsFixed={rowsColumnsFixed}
      onFixRowsColumns={onFixRowsColumns}
      height={rowsColumnsFixed ? "750px" : "100%"}
      containerWidth={rowsColumnsFixed ? window.innerWidth < 1350 ? "92.5vw" : window.innerWidth < 1900 ? "93.5vw" : "94.5vw" : "100%"}
      gridWidth={"100%"}
      minHeight={450}
      gridContainerOverflowX={gridContainerOverflowX}
      onLoadDataImport={props.onLoadDataImport}
      selectedTotalRows={selectedTotalRows}
      onSelectedTotalRowsChange={onSelectedTotalRowsChange}
      totalRowsOptions={rowFieldsFromDataSource && rowFieldsFromDataSource.current}
      isLoadingDataSource={isLoadingDataSource && isLoadingDataSource[0]}
      scrollingMode={scrollingMode}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    loading: state.ventas.cuboVentasData.loading,
    error: state.ventas.cuboVentasData.error,
    estaCargado: state.ventas.cuboVentasData.estaCargado,
    datos: state.ventas.cuboVentasData.datos,
    config: state.ventas.cuboVentasData.config,
    aprobado: state.ventas.cuboVentasData.aprobado,
    filtros: state.ventas.cuboVentasFiltros,
    configFields: state.tenacta.pivotGridConfiguracionFields.items,
    selectedTotalRowsItems: state.tenacta.selectedTotalRows.items,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadData: (request, config) => dispatch(actions.loadCuboVentasData(request, undefined, undefined, config)),
    onUpdateData: (data, config, filtros) => dispatch(actions.updateCuboVentasData(data, config, filtros)),
    onUpdateConfigFields: (key, config) => dispatch(actions.updateConfiguracionFields(key, config)),
    onUpdateFiltros: (desde, hasta, anioComparacion, filtroAplicado) => dispatch(actions.updateCuboVentasFiltros(desde, hasta, anioComparacion, filtroAplicado)),
    onLoadDataImport: (request, success, fail) => dispatch(actions.loadCuboVentasData(request, success, fail, undefined)),
    onUpdateSelectedTotalRows: (key, rows) => dispatch(actions.updateSelectedTotalRows(key, rows)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PivotGridCuboVentas);